import { render, staticRenderFns } from "./OurUsersSaySection.vue?vue&type=template&id=11179033&"
import script from "./OurUsersSaySection.vue?vue&type=script&lang=ts&"
export * from "./OurUsersSaySection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseSectionTitle: require('/codebuild/output/src2039654861/src/threease_lp/components/shared/Base/BaseSectionTitle.vue').default,UserSayCard: require('/codebuild/output/src2039654861/src/threease_lp/components/features/commonSection/userSay/UserSayCard.vue').default,BaseMaxWidthContainer: require('/codebuild/output/src2039654861/src/threease_lp/components/shared/Base/BaseMaxWidthContainer.vue').default})
